/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/13/21
 */

import {gql} from "urql";
import {Calendar, ListResponse} from "../../interfaces/Global";

export const SavedCalendarsQuery = gql`
	query SavedCalendars($createdBy: String, $idIn: [ID!], $titleLike: String, $search: String, $orderBy: String, $offset: Int, $limit: Int) {
		savedCalendars(createdBy: $createdBy, idIn: $idIn, titleLike: $titleLike, search: $search, orderBy: $orderBy, offset: $offset, limit: $limit) {
			total
			items {
                id
                createdBy
                creationDate
                createdByEmployee {
                    id
                    displayName
                }
                modifiedBy
                modifiedDate
                vstamp
                title
                config
				vstamp
            }
		}
	}
`;

export interface SavedCalendarsResponse {
	savedCalendars: ListResponse<Calendar>
}

export interface SavedCalendarsQueryVars {
	idIn?: number[]
	titleLike?: string
	createdBy?: string
	orderBy?: string
	limit?: number
	offset?: number
	search?: string
}

export const SavedCalendarQuery = gql`
	query SavedCalendar($id: ID!) {
		savedCalendar(id: $id) {
			id
			createdBy
			creationDate
            createdByEmployee {
                id
                displayName
            }
			modifiedBy
			modifiedDate
			vstamp
			title
			config
			vstamp
			lastAccessed
			accessCount
		}
	}
`;

export interface SavedCalendarResponse {
	savedCalendar: Calendar
}

export interface SavedCalendarQueryVars {
	id: number
}